<script lang="ts" setup>
import type { IconProps } from '@nuxt/ui';
import { tv } from 'tailwind-variants';
import { computed } from 'vue';
import ImageComponent from '#build/ui-image-component';
import { isUrl } from '#layers/ui/utils/url';

const props = defineProps<{
	icon: IconProps['name'];
	ui?: Partial<typeof iconOrImage['slots']>;
}>();

const iconOrImage = tv({
	slots: {
		image: '',
		icon: '',
	},
});

const ui = computed(() => iconOrImage(props));

const isImage = computed(() => typeof props.icon === 'string' ? isUrl(props.icon) : false);
</script>

<template>
	<ImageComponent
		v-if="isImage"
		:src="props.icon as string"
		:alt="props.icon as string"
		:class="ui.image({ class: props.ui?.image })"
	/>
	<DIcon
		v-else
		:name="props.icon"
		:class="ui.icon({ class: props.ui?.icon })"
	/>
</template>
